import { render, staticRenderFns } from "./article-detail.vue?vue&type=template&id=201e27a6&scoped=true"
import script from "./article-detail.vue?vue&type=script&lang=js"
export * from "./article-detail.vue?vue&type=script&lang=js"
import style0 from "./article-detail.vue?vue&type=style&index=0&id=201e27a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "201e27a6",
  null
  
)

export default component.exports